import Products from "./components/Products";

function App() {
  return (
    <div>
      <Products />
    </div>
  );
}

export default App;
